<script setup>
import { computed, onBeforeMount } from "vue";
import { useStore } from "vuex";
import Sidenav from "./examples/Sidenav";
import Navbar from "@/examples/Navbars/Navbar.vue";
import axios from "axios";
import cookies from "./assets/js/cookies";
import mobileNav from "./components/mobileNav.vue";
import QuickAction from "./components/QuickAction.vue";
import {activateDarkMode, deactivateDarkMode} from "@/assets/js/dark-mode";
import validSession from "./assets/js/valid-session";

const store = useStore();
const isNavFixed = computed(() => store.state.isNavFixed);
const darkMode = computed(() => store.state.darkMode);
const isAbsolute = computed(() => store.state.isAbsolute);
const showSidenav = computed(() => store.state.showSidenav);
const layout = computed(() => store.state.layout);
const showNavbar = computed(() => store.state.showNavbar);
const body = document.getElementsByTagName("body")[0];

const setSidebarType = (type) => store.commit("sidebarType", type);

onBeforeMount(() => {

  validSession.isLogged();

  let session = cookies.get('user_agive_session');

  body.classList.add("bg-default");

  if(session !== null){
    getUserData();
  }
  
});

//axios.defaults.baseURL = 'http://localhost:8081';
//axios.defaults.baseURL = 'https://financas-api-hml.agive.com.br';
axios.defaults.baseURL = 'https://financas-api-prod.agive.com.br';
axios.defaults.headers.common['Auth-Token'] = 'rFdwkqOA3BhHCpbDHT1T57X55Bs1thFmdCrbWhG9k9ikmQz4bu';
axios.defaults.headers.common['Session-Token'] = cookies.get('user_agive_session') != null ? cookies.get('user_agive_session') : '';

const navClasses = computed(() => {
  return {
    "position-sticky bg-white left-auto top-2 z-index-sticky":
      isNavFixed.value && !darkMode.value,
    "position-sticky bg-default left-auto top-2 z-index-sticky":
      isNavFixed.value && darkMode.value,
    "position-absolute px-4 mx-0 w-100 z-index-2": isAbsolute.value,
    "px-0 mx-md-4": !isAbsolute.value,
  };
});

const getUserData = async () => {

  axios.get('users/data')
  .then(res => {
      
      if(res.status === 200){

        cookies.add('user_agive_email', res.data.email, 86400);
        cookies.add('user_agive_name', res.data.name, 86400);

        if(res.data.darkmode === 'Yes'){

          store.state.darkMode = true;
          setSidebarType("bg-default");
          activateDarkMode();

        }
        else{

          store.state.darkMode = false;
          setSidebarType("bg-white");
          deactivateDarkMode();

        }

        store.state.welcomeMessage = 'Olá, '+res.data.name+'!';

      }
      
  })
  .catch(err => {
      console.error(err); 
  })

}
</script>

<template>
  <div
    v-show="layout === 'landing'"
    class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
  ></div>

  <sidenav v-if="showSidenav" />

  <main
    class="main-content position-relative"
  >
    <!-- nav -->

    <navbar :class="[navClasses]" v-if="showNavbar" />

    <router-view />

    <QuickAction />
    
    <mobileNav />

  </main>

  
</template>
